export default __webpack_public_path__ + "static/media/logoColorS.f97e44a3.webp";